module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/apple_on_color-43fb8f0d.svg";